<template>
  <div class="form_box">
      <div class="form_box__header">
        <AppPageHeader></AppPageHeader>
      </div>
      <el-card class="box-card">
        <div class="form_box__group__item">
          <div class="form_box__group__item__title">姓名：</div>
          <div class="form_box__group__item__content">{{user.name}} <el-tag v-if="user.isccp == 1" class="ml-2">党员</el-tag><el-tag v-if="user.isccp == 0" type="info" class="ml-2">非党员</el-tag></div>
        </div>
      
        <div class="form_box__group__item">
          <div class="form_box__group__item__title">当年学时：</div>
          <div class="form_box__group__item__content">{{user.currentScore}}</div>
        </div>

        <div class="form_box__group__item" v-if="user.passYearScore">
          <div class="form_box__group__item__title">历史学时：</div>
          <div class="form_box__group__item__content">{{user.passYearScore}}</div>
        </div>

        <div class="form_box__group__item">
          <div class="form_box__group__item__title">单位：</div>
          <div class="form_box__group__item__content">{{user.unitTitle}}</div>
        </div>

        <template v-if="user.isccp == 1">
          <div class="form_box__group__item">
            <div class="form_box__group__item__title">所属党组织：</div>
            <div class="form_box__group__item__content">{{user.partyTitle}}</div>
          </div>
        </template>

      </el-card>

      <el-card class="box-card">


        <el-tabs v-model="hourDetailType" @tab-click="onClickHDTab">
          <el-tab-pane label="学时详细" name="total">
          </el-tab-pane>
          <el-tab-pane label="当年学时详细" name="current">
          </el-tab-pane>
          <el-tab-pane label="历年学时详细" name="legacy">
          </el-tab-pane>
        </el-tabs>

        <div>
          <HourDetailTableYears ref="HourDetailYearRef" v-if="hourDetailType == 'total'"></HourDetailTableYears>
          <HourDetailTableCurrentYear ref="HourDetailTableCurrentYear" :dataType="0"  v-if="hourDetailType == 'current'"></HourDetailTableCurrentYear>
          <HourDetailTableCurrentYear ref="HourDetailTablePassYear" :dataType="1"  v-if="hourDetailType == 'legacy'"></HourDetailTableCurrentYear>
        </div>


      </el-card>
  </div>
</template>


<script>

import { HourDetailTableCurrentYear,HourDetailTableYears } from "./comp"
import { getClassHoursDetailApi } from "@/api/module/classHours/classHours";

export default {
  name: "class-hours-detail",
  props:{
    timetype:{
      type: Number
    }
  },
  components: {
    HourDetailTableCurrentYear,
    HourDetailTableYears
  },
  data() {
    return {
      user : {},
      hourDetailType: "total"  // 学习详细类型  total，current , legancy
    }
  },
  methods:{
    getClassHoursDetail() {
      let data = {
        uid: this.uid
      };
      getClassHoursDetailApi(data)
        .then((res) => {
          console.log("res",res)

          this.user = res;

        })
    },

    onClickHDTab(val,val2,val3){
      console.log("onClickHDTab",this.hourDetailType)      


      if(this.hourDetailType == "legacy"){
        this.$nextTick(()=>{
          this.$refs.HourDetailTablePassYear.init();
        })        
      }

      if(this.hourDetailType == "current"){
        this.$nextTick(()=>{
          this.$refs.HourDetailTableCurrentYear.init();
        })
      }

    }
  },

  created(){
    this.uid = this.$route.query.id;
    this.getClassHoursDetail();
  }
}


</script>


<style scoped lang='scss'>
.box-card {
  margin-bottom: 20px;
  .userName {
    padding-left: 10px;
    margin-bottom: 10px;
    .title {
      color: #303133;
      font-size: 14px;
      font-weight: 500;
      display: inline-block;
      width: 70px;
    }
    .cont {
      font-size: 14px;
      color: #3e3e3e;
    }
  }
}
.clearfix {
  font-size: 16px;
  color: #303133;
  font-weight: 600;
}
.el-pagination {
  text-align: center;
  margin-top: 30px;
}
</style>